import React, { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';

export default function LanguageSwitcher() {
  const { language, setLanguage } = useContext(LanguageContext);

  const buttonStyle = (lang) => ({
    fontWeight: language === lang ? 'bold' : 'normal',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    margin: '0 5px',
    fontSize: '14px'
  });

  return (
    <div style={{ position: 'fixed', top: 20, right: 20, zIndex: 1000 }}>
      <button style={buttonStyle('EN')} onClick={() => setLanguage('EN')}>
        EN
      </button>
      |
      <button style={buttonStyle('PT')} onClick={() => setLanguage('PT')}>
        PT
      </button>
    </div>
  );
}